var _excluded = ["src"];

function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React from "react";
import * as Icon from "./icons";
export var IconSvg = function IconSvg(props) {
  var src = props.src,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);

  switch (src) {
    case "search":
      return /*#__PURE__*/ React.createElement(Icon.Search, restProps);

    case "passwordKey":
      return /*#__PURE__*/ React.createElement(Icon.PasswordKey, restProps);

    case "arrowDown":
      return /*#__PURE__*/ React.createElement(Icon.ArrowDown, restProps);

    case "arrowUp":
      return /*#__PURE__*/ React.createElement(Icon.ArrowUp, restProps);

    case "bicycle":
      return /*#__PURE__*/ React.createElement(
        Icon.Bicycle,
        _extends(
          {
            width: "32px",
            height: "32px",
          },
          restProps
        )
      );

    case "drop":
      return /*#__PURE__*/ React.createElement(
        Icon.Drop,
        _extends(
          {
            width: "32px",
            height: "32px",
          },
          restProps
        )
      );

    case "running":
      return /*#__PURE__*/ React.createElement(
        Icon.Running,
        _extends(
          {
            width: "32px",
            height: "32px",
          },
          restProps
        )
      );

    case "swimmer":
      return /*#__PURE__*/ React.createElement(
        Icon.Swimmer,
        _extends(
          {
            width: "32px",
            height: "32px",
          },
          restProps
        )
      );

    case "wind":
      return /*#__PURE__*/ React.createElement(
        Icon.Wind,
        _extends(
          {
            width: "32px",
            height: "32px",
          },
          restProps
        )
      );

    case "path":
      return /*#__PURE__*/ React.createElement(
        Icon.Path,
        _extends(
          {
            width: "8px",
            height: "14px",
          },
          restProps
        )
      );

    case "status":
      return /*#__PURE__*/ React.createElement(
        Icon.Status,
        _extends(
          {
            width: "6px",
            height: "6px",
          },
          restProps
        )
      );

    case "down":
      return /*#__PURE__*/ React.createElement(
        Icon.Down,
        _extends(
          {
            width: "14px",
            height: "8px",
          },
          restProps
        )
      );

    case "close":
      return /*#__PURE__*/ React.createElement(
        Icon.Close,
        _extends(
          {
            width: "26px",
            height: "26px",
          },
          restProps
        )
      );

    case "lightClose":
      return /*#__PURE__*/ React.createElement(
        Icon.LightClose,
        _extends(
          {
            width: "20px",
            height: "20px",
          },
          restProps
        )
      );

    case "darkClose":
      return /*#__PURE__*/ React.createElement(
        Icon.DarkClose,
        _extends(
          {
            width: "26px",
            height: "26px",
          },
          restProps
        )
      );

    case "telegram":
      return /*#__PURE__*/ React.createElement(
        Icon.Telegram,
        _extends(
          {
            width: "17px",
            height: "14px",
          },
          restProps
        )
      );

    case "facebook":
      return /*#__PURE__*/ React.createElement(
        Icon.Facebook,
        _extends(
          {
            height: "22px",
          },
          restProps
        )
      );

    case "instagram":
      return /*#__PURE__*/ React.createElement(
        Icon.Instagram,
        _extends(
          {
            height: "22px",
          },
          restProps
        )
      );

    case "vk":
      return /*#__PURE__*/ React.createElement(
        Icon.VK,
        _extends(
          {
            height: "22px",
          },
          restProps
        )
      );

    case "vk-2":
      return /*#__PURE__*/ React.createElement(
        Icon.Vkontakte,
        _extends(
          {
            height: "22px",
          },
          restProps
        )
      );

    case "youtube":
      return /*#__PURE__*/ React.createElement(
        Icon.Youtube,
        _extends(
          {
            height: "20px",
          },
          restProps
        )
      );

    case "play":
      return /*#__PURE__*/ React.createElement(
        Icon.Play,
        _extends(
          {
            width: "80px",
            height: "80px",
          },
          restProps
        )
      );

    case "download":
      return /*#__PURE__*/ React.createElement(
        Icon.Download,
        _extends(
          {
            width: "24px",
            height: "22px",
          },
          restProps
        )
      );

    case "marketLogo":
      return /*#__PURE__*/ React.createElement(Icon.MarketLogo, restProps);

    case "moscow":
      return /*#__PURE__*/ React.createElement(Icon.Moscow, restProps);

    case "user":
      return /*#__PURE__*/ React.createElement(
        Icon.User,
        _extends(
          {
            width: "32px",
            height: "32px",
          },
          restProps
        )
      );

    case "backed":
      return /*#__PURE__*/ React.createElement(
        Icon.Backed,
        _extends(
          {
            width: "19px",
            height: "19px",
          },
          restProps
        )
      );

    case "leftButton":
      return /*#__PURE__*/ React.createElement(
        Icon.LeftSlider,
        _extends(
          {
            width: "10px",
            height: "18px",
          },
          restProps
        )
      );

    case "rightButton":
      return /*#__PURE__*/ React.createElement(
        Icon.RightSlider,
        _extends(
          {
            width: "10px",
            height: "18px",
          },
          restProps
        )
      );

    case "calendar":
      return /*#__PURE__*/ React.createElement(
        Icon.Calendar,
        _extends(
          {
            width: "18px",
            height: "20px",
          },
          restProps
        )
      );

    case "email":
      return /*#__PURE__*/ React.createElement(
        Icon.Email,
        _extends(
          {
            width: "20px",
            height: "16px",
          },
          restProps
        )
      );

    case "tel":
      return /*#__PURE__*/ React.createElement(
        Icon.Tel,
        _extends(
          {
            width: "10px",
            height: "16px",
          },
          restProps
        )
      );

    case "tShirt":
      return /*#__PURE__*/ React.createElement(
        Icon.TShirt,
        _extends(
          {
            width: "14px",
            height: "16px",
          },
          restProps
        )
      );

    case "default":
      return /*#__PURE__*/ React.createElement(
        Icon.Default,
        _extends(
          {
            width: "13px",
            height: "16px",
          },
          restProps
        )
      );

    case "userName":
      return /*#__PURE__*/ React.createElement(
        Icon.UserName,
        _extends(
          {
            width: "17px",
            height: "18px",
          },
          restProps
        )
      );

    default:
      return null;
  }
};
